import { MobileDriveSelectorPanel } from '@src/js/common/ark-extensions/dc-components/docs-component-drive-selector-panel/mobile';
import { BaseDriveSelectorPanelService } from '../base';
import { IShowArgs } from '../interface';

export class MobileDriveSelectorPanelService extends BaseDriveSelectorPanelService {
    public async show({ serviceList, config }: IShowArgs) {
        this.serviceList = serviceList;
        await MobileDriveSelectorPanel.getInstance().showDriveSelectorPanel({
            config: {
                ...config,
                onResolve: this.onResolve.bind(this),
            },
        });
        return this;
    }
}
